import { fetchWithAuthHeader } from '../../auth';
import { jsonResponseHandling } from '../fetch';
import { apiUrl, TRAFFIC_PATH } from '../api-manager';

export const fetchTrafficFlows = async (lat, long, radius, detailed) => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/traffic/flows?long=${long}&lat=${lat}&radius=${radius}&detailed=${detailed}`),
    {
        method: 'GET',
    },
).then(response => jsonResponseHandling(response));

export const calculateRoute = async points => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/routing/directions/calculate`),
    {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            points,
            apiVersion: 2,
            instructionsType: 'coded',
            guidanceVersion: 2,
            language: 'en-US',
            instructionPhonetics: 'LHP',
            instructionRoadShieldReferences: 'all',
        }),
    },
).then(response => jsonResponseHandling(response));
